export const areaUniquenessKey = (area = {}) => {
  const normalizedName = String(area?.name || "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

  if (normalizedName) return `name:${normalizedName}`;

  const lat = Number.parseFloat(area?.latitude ?? area?.centroid?.lat);
  const lng = Number.parseFloat(area?.longitude ?? area?.centroid?.lng);

  if (Number.isFinite(lat) && Number.isFinite(lng)) {
    return `coords:${lat.toFixed(6)}:${lng.toFixed(6)}`;
  }

  return String(area?.id || area?._id || area?.areaId || "");
};

export const uniqueAreas = (areas = []) => {
  const seen = new Set();

  return areas.filter((area, index) => {
    const key = areaUniquenessKey(area) || `area:${index}`;

    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
